module.exports = __webpack_public_path__ + "img/AD_page_02.515dfa83.jpg";